<template>
  <div class="items-end">
    <NotFoundData
      text="Dados indisponíveis no momento!"
      v-if="!series.length"
    />
    <!-- <PieChart
      :chart-data="chartData"
      :options="chartOptions"
      v-else
    /> -->

    <div v-else id="chart">
      <div class="flex absolute right-0">
        <p class="pr-3">%</p>
        <b-switch v-model="isValor" outlined> Qtd </b-switch>
      </div>
      <apexchart
        type="radialBar"
        height="300"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import PieChart from "@/components/Chart/PieChart";
import { twColors, twFonts } from "@/services/tailwindConfig";
import NotFoundData from "@/components/layouts/NotFoundData";

export default {
  name: "ResumoGeralEmpresas",
  components: { PieChart, NotFoundData },
  props: {
    values: Object,
  },
  data() {
    return {
      loadingChart: true,
      notFoundData: false,
      isValor: true,
      notFoundMessage: "",
    };
  },
  watch: {
    isValor() {
      console.log(this.isValor);
    },
  },
  computed: {
    chartOptions() {
      let data = {
        chart: {
          height: 300,
          type: "radialBar",
        },

        plotOptions: {
          radialBar: {
            offsetY: 0,
            offsetX: 0,

            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        colors: [
        twColors.error.dark,
        twColors.primary[700],

          twColors.primary[400],
          twColors.info.dark,
        ],
        labels: [ "Saíram","Ativa", "Em Abertura", "Congelada", ],
        fill: {
          type: "gradient",
        },
        legend: {
          show: true,
          floating: true,
          fontSize: "13px",
          position: "left",
          offsetX: -30,
          offsetY: 0,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
          formatter: function (seriesName, opts) {
            return (
              seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] * 10
            );
          },
          itemMargin: {
            vertical: 1,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      };
      if (this.isValor) {
        
        let sum = this.total;
      
     
        data.legend.formatter = function (seriesName, opts) {
          return seriesName + ":  " + Math.round(opts.w.globals.series[opts.seriesIndex] * (sum) / 100) ;
        };
        return data;
      } else {
        data.legend.formatter = function (seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] +'%';
        };
        return data;
      }
    },

    series() {
      return [
      this.formatter(this.values.inativa) ,

        this.formatter(this.values.ativa),
        this.formatter(this.values.em_abertura),
        this.formatter(this.values.congelada),
      ];
    },
    // chartData() {
    //   return {
    //     labels: ['Ativa', 'Em Abertura', 'Congelada', 'Saíram'],
    //     datasets: [{
    //       data:
    //       backgroundColor: ,
    //       type: 'pie',
    //       datalabels: {
    //         formatter: this.formatter,
    //         backgroundColor: `rgba(0, 0, 0, .5)`,
    //         borderRadius: 4,
    //         color: twColors.neutral[100],
    //         padding: {
    //           top: 2,
    //           right: 4,
    //           bottom: 0,
    //           left: 4
    //         },
    //         font: {
    //           family: twFonts.body,
    //           size: 12
    //         }
    //       }
    //     }]
    //   }
    // },
   
    total(){

     let dataArr=   [
        this.values.ativa,
        this.values.em_abertura,
        this.values.congelada ,
        this.values.inativa ,
      ];
      let sum = 0;
      
      for (var i = 0; i < dataArr.length; i++) {
        sum += parseInt(dataArr[i]);
      }
      return sum
    }
  },
  methods:{
    formatter(value) {
    
console.log(this.total )
      return ((value * 100) / this.total ).toFixed(2);
    },
  }
};
</script>
